import { c as _c } from "react/compiler-runtime";
import { SuccessCheck } from '@onefootprint/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TRANSITION_DELAY_DEFAULT } from '../../constants';
type SuccessProps = {
  onComplete?: () => void;
};
const Success = t0 => {
  const $ = _c(9);
  const {
    onComplete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.success"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  let t3;
  if ($[1] !== onComplete) {
    t2 = () => {
      if (onComplete) {
        setTimeout(onComplete, TRANSITION_DELAY_DEFAULT);
      }
    };
    t3 = [onComplete];
    $[1] = onComplete;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SuccessCheck animationStart={true} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="flex flex-col items-center">{t4}<div className="text-label-1 text-center mt-4 text-success">{t5}</div></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default Success;
function _temp($) {
  return $.title;
}